import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FULL_TESTIMONIALS } from '../../data/content';
function getInitials(name: string) {
  return name.split(' ').map(part => part.charAt(0)).join('').slice(0, 2);
}
export function Testimonials() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-249" data-mp="3r9byr4orw4f8">
      <div className="mx-auto max-w-5xl" data-id="element-250" data-mp="69d5xmoyp7">
        <Reveal className="text-center" data-id="element-251" data-mp="3k884732prw">
          <SectionBadge data-id="element-252" data-mp="421hata2eaby">Testimonios</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-253" data-mp="44w1cjp61t4u">
            Lo que dicen <span className="u-lime" data-id="element-254" data-mp="e0qpfuc5sgf0">+500 profesoras</span>
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-2" data-id="element-255" data-mp="2at908lapldbn">
          {FULL_TESTIMONIALS.map((testimonial, index) => <Reveal key={testimonial.name} delay={index % 2 * 80} as="article" data-id="element-256" data-mp="2fru02jm1tuzk" data-mpi={index}>
              <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink/90 p-5 sm:p-6" data-id="element-257" data-mp="1skj3c9xwcvjw">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-258" data-mp="1nu2msgys4ttb">
                  {Array.from({
                length: 5
              }).map((_, starIndex) => <StarIcon key={starIndex} className="h-4 w-4 fill-lime text-lime" aria-hidden="true" data-id="element-259" data-mp="1iv9dl0qizoyy" data-mpi={starIndex} />)}
                </span>

                <p className="mt-3.5 flex-1 text-sm leading-relaxed text-snow sm:text-base" data-id="element-260" data-mp="2bjx1l42nssg7">
                  “{testimonial.quote}”
                </p>

                <div className="mt-5 flex items-center gap-3 border-t border-ink-line pt-4" data-id="element-261" data-mp="26l3kl1o5yjba">
                  <span aria-hidden="true" className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-rose text-xs font-extrabold text-snow" data-id="element-262" data-mp="22gvv329vszc0">
                    {getInitials(testimonial.name)}
                  </span>
                  <span data-id="element-263" data-mp="m35onovahyz7">
                    <span className="block text-sm font-bold text-snow" data-id="element-264" data-mp="m6th0kp00fcc">{testimonial.name}</span>
                    <span className="block text-xs text-snow-dim" data-id="element-265" data-mp="njtc4kjbu5ga">{testimonial.city}</span>
                  </span>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}